import {
  Box,
  Button,
  Card,
  CardMedia, Tooltip,
  Typography, useMediaQuery, useTheme
} from '@mui/material';
import PassedIcon from '../../assets/images/passed-icon.svg';
import OutstandingIcon from '../../assets/images/outstanding-icon.svg';
import AssignedIcon from '../../assets/images/assigned-icon.svg';
import EventIcon from '@mui/icons-material/Event';
import './HorizontalCard.css';
import React from 'react';
import { HorizontalCardProps } from './HorizontalCard.props';
import moment from 'moment';
import {handleStartCourse, parseImgURL} from '../../utils/util';
import './styles/ipad.css';
import './styles/mobile.css';
import { convertUtcToTimezone } from '../../utils/dateTimeHelper';
import {COURSE_POLICY_STATUS, FORMAT_DATE, STATUS_COURSE} from '../../constants/constants';
import {getTrainingLink} from "../../api/platform";
import QuestionnaireIcon from '../../assets/images/questionnaire-icon.svg';
export const HorizontalCard: React.FC<HorizontalCardProps> = (props) => {
  const { horizontalCardData } = props;
  const utcByTimezone = convertUtcToTimezone(horizontalCardData?.end_date);
  const theme =useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'))


  const showTagIconIncludedTooltip = (tagIcon?: string) => {
    const tags = {
      Passed: {
        title: 'Passed',
        icon: () => {
          return isMobile ?  <img src={PassedIcon} className={'completed'} width={'38px'} height={'38px'} /> :   <img src={PassedIcon} className={'completed'} />;
        }
      },

      Outstanding: {
        title: 'Outstanding',
        icon: () => {
          return isMobile ?  <img src={OutstandingIcon} className={'outstanding'} width={'50px'} height={'50px'}/>:  <img src={OutstandingIcon} className={'outstanding'} />;
        }
      },
      Assigned: {
        title: 'Assigned',
        icon: () => {
          return isMobile ?  <img src={AssignedIcon} className={'assigned'} width={'50px'} height={'50px'} /> : <img src={AssignedIcon} className={'assigned'} /> ;
        }
      },
      [STATUS_COURSE.QUESTIONNAIRE]: {
        title: 'Completed',
        icon: () => {
          return isMobile ?  <img src={QuestionnaireIcon} className={'assigned'} width={'50px'} height={'50px'} /> : <img src={QuestionnaireIcon} className={'assigned'} /> ;
        }
      }
    };
    if (tagIcon) {
      return (
          <Tooltip
              PopperProps={{
                     sx:{marginBottom:'-59px !important'}
                   }}
              placement={'top-start'}
              title={`${tags[tagIcon as keyof typeof tags].title}`}
          >
            {tags[tagIcon as keyof typeof tags]?.icon()}
          </Tooltip>
      );
    }
  };

  const checkStartCourse =(value:any)=> {
    const params={
      course_id: value?.course_id,
      campaign_id: value?.campaign_id,
      token_1: value?.token_1,
      token_2: value?.token_2,
    }
    getTrainingLink(params).then((res: any)=>{
      if(res && res.data){
        handleStartCourse(value.token_1, value.token_2);
      }
    }).catch((e:any) =>{
      console.log(e)})
  }

  const showButtonStartCourse= (latestScore:string,trainingLabel:string,coursePolicy: number | undefined, courseType: number | undefined) => {
    return (<div className={'btn-wrapper'}>
      {(trainingLabel === STATUS_COURSE.PASS && (coursePolicy === COURSE_POLICY_STATUS.ACCEPTED || coursePolicy === COURSE_POLICY_STATUS.NA)) ? (
          <Typography className={'grade-btn'}>
            Grade | {latestScore}%
          </Typography>
      ) : (
        <Button
          data-testid="btn-start-course"
          className={'course-card-btn'}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            checkStartCourse(horizontalCardData);
          }}
          disabled={ (courseType && trainingLabel === STATUS_COURSE.QUESTIONNAIRE) ? true : false }
        >
          Start Course
        </Button>
      )}
    </div>)
  }
  return (
    <>
      <Card className={'course-card-style course-card-action ' + `${props?.className}`} onClick={props.onSelected}>
          <Box  className={'course-wrapper'} onClick={props.clickToDetail}>
            <div className={'course-wrapper-elements'}>
              <div className={'course-header'}>
                <div className={'course-header-wrapper-img'}>
                  <CardMedia
                    component={'img'}
                    alt={horizontalCardData?.tp_thumbnail}
                    className={'course-thumbnail'}
                    image={`${parseImgURL(
                      horizontalCardData?.tp_thumbnail,
                      horizontalCardData?.tp_id
                    )}`}
                  />
                </div>

                <div className={'course-contain'}>
                  <Typography className={'title text-truncate multiline-ellipsis'}>
                    {horizontalCardData?.course_name ?? ''}
                  </Typography>
                  <Typography className={'sub-title text-truncate multiline-ellipsis'}>
                    {horizontalCardData?.course_category_name ?? ''}
                  </Typography>

                </div>
                {
                  isMobile ? showTagIconIncludedTooltip (horizontalCardData.training_label) : null
                }
              </div>
              <div className="course-infos-wrapper">
                <Box className={'course-infos'} component={'div'}>
                  {showButtonStartCourse(horizontalCardData?.latest_score,horizontalCardData?.training_label, horizontalCardData?.course_policy_status, horizontalCardData?.course_type)}
                  <div className={'course-info'}>
                    <Box className={'box-due-date'}>
                      <Tooltip title={'Due Date'} placement={'top'}>
                        <EventIcon className={'calendar-icon'} />
                      </Tooltip>
                      <Typography className={'date-month'}>
                        {moment(utcByTimezone).format(FORMAT_DATE.DATE_DAY_MONTH_YEAR) ?? ''}
                      </Typography>
                    </Box>
                  </div>

                </Box>
              </div>
            </div>
            { isMobile? null : showTagIconIncludedTooltip(horizontalCardData.training_label)}
          </Box>
      </Card>
    </>
  );
};
